import _ from "lodash";

export default (url) => {
  window.open(url, "_blank");
};
